/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/trash.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Trash',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.05 4.54922V11.9992C4.05 12.8 4.69919 13.4492 5.5 13.4492H10.5C11.3008 13.4492 11.95 12.8 11.95 11.9992V4.54922H4.05ZM11.05 2.99922V3.44922H13.95C14.2538 3.44922 14.5 3.69546 14.5 3.99922C14.5 4.30297 14.2538 4.54922 13.95 4.54922H13.05V11.9992C13.05 13.4075 11.9083 14.5492 10.5 14.5492H5.5C4.09167 14.5492 2.95 13.4075 2.95 11.9992V4.54922H2.05C1.74624 4.54922 1.5 4.30297 1.5 3.99922C1.5 3.69546 1.74624 3.44922 2.05 3.44922H4.95V2.99922C4.95 2.14318 5.64396 1.44922 6.5 1.44922H9.5C10.356 1.44922 11.05 2.14318 11.05 2.99922ZM6.05 3.44922V2.99922C6.05 2.75069 6.25147 2.54922 6.5 2.54922H9.5C9.74853 2.54922 9.95 2.75069 9.95 2.99922V3.44922H6.05ZM6.6 6.54922C6.6 6.24546 6.35376 5.99922 6.05 5.99922C5.74624 5.99922 5.5 6.24546 5.5 6.54922L5.5 11.4492C5.5 11.753 5.74624 11.9992 6.05 11.9992C6.35376 11.9992 6.6 11.753 6.6 11.4492V6.54922ZM8.05 5.99922C8.35376 5.99922 8.6 6.24546 8.6 6.54922V11.4492C8.6 11.753 8.35376 11.9992 8.05 11.9992C7.74624 11.9992 7.5 11.753 7.5 11.4492V6.54922C7.5 6.24546 7.74624 5.99922 8.05 5.99922ZM9.5 6.54922V11.4492C9.5 11.753 9.74624 11.9992 10.05 11.9992C10.3538 11.9992 10.6 11.753 10.6 11.4492L10.6 6.54922C10.6 6.24546 10.3538 5.99922 10.05 5.99922C9.74624 5.99922 9.5 6.24546 9.5 6.54922Z"
            fill="currentColor"
          />
        </>
      )
    },
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 6H4V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V6ZM5.25 19V7.25H18.75V19C18.75 19.9665 17.9665 20.75 17 20.75H7C6.0335 20.75 5.25 19.9665 5.25 19Z"
            fill="currentColor"
          />{' '}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.5 1.37305C7.77301 1.37305 6.373 2.77305 6.373 4.50005V5.87305H2.5V7.12705H21.5V5.87305H17.627V4.50005C17.627 2.77305 16.227 1.37305 14.5 1.37305H9.5ZM16.373 5.87305H7.627V4.50005C7.627 3.46562 8.46557 2.62705 9.5 2.62705H14.5C15.5344 2.62705 16.373 3.46562 16.373 4.50005V5.87305Z"
            fill="currentColor"
          />{' '}
          <path
            d="M11.3738 9.52466C11.3738 9.17948 11.6536 8.89966 11.9988 8.89966C12.3439 8.89966 12.6238 9.17948 12.6238 9.52466V18.4365C12.6238 18.7817 12.3439 19.0615 11.9988 19.0615C11.6536 19.0615 11.3738 18.7817 11.3738 18.4365V9.52466Z"
            fill="currentColor"
          />{' '}
          <path
            d="M7.37376 9.52466C7.37376 9.17948 7.65358 8.89966 7.99876 8.89966C8.34394 8.89966 8.62376 9.17948 8.62376 9.52466V18.4365C8.62376 18.7817 8.34394 19.0615 7.99876 19.0615C7.65358 19.0615 7.37376 18.7817 7.37376 18.4365V9.52466Z"
            fill="currentColor"
          />{' '}
          <path
            d="M15.3738 9.52466C15.3738 9.17948 15.6536 8.89966 15.9988 8.89966C16.3439 8.89966 16.6238 9.17948 16.6238 9.52466V18.4365C16.6238 18.7817 16.3439 19.0615 15.9988 19.0615C15.6536 19.0615 15.3738 18.7817 15.3738 18.4365V9.52466Z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
